import { render, staticRenderFns } from "./puhuoDialog.vue?vue&type=template&id=27a26fb1&scoped=true"
import script from "./puhuoDialog.vue?vue&type=script&lang=js"
export * from "./puhuoDialog.vue?vue&type=script&lang=js"
import style0 from "./puhuoDialog.vue?vue&type=style&index=0&id=27a26fb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a26fb1",
  null
  
)

export default component.exports